// src/hooks/useModal.js
import { useState } from 'react';

export function useModal() {
  const [isOpen, setIsOpen] = useState(false);
  const [modalConfig, setModalConfig] = useState({
    title: '',
    message: '',
    onConfirm: () => {},
    confirmText: 'Confirm',
    cancelText: 'Cancel',
    type: 'danger'
  });

  const openModal = (config) => {
    setModalConfig(config);
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  const confirm = async () => {
    if (modalConfig.onConfirm) {
      await modalConfig.onConfirm();
    }
    closeModal();
  };

  return {
    isOpen,
    modalConfig,
    openModal,
    closeModal,
    confirm
  };
}
